import styled from "styled-components";
import { devices } from "../../ExternFormEnrollment.styles";

export const Question = styled.p`
  margin-bottom: 0px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  margin-bottom: 25px;
  @media ${devices.tablet} {
    flex-direction: row;
    gap: 15px;
  }
`;

export const BackgroundColor = styled.div` 
  background-color: var(--color-greylight);
  padding: 20px;
  width: 100%;
`;

export const WrapperSelect = styled.div`
  margin-bottom: 28px;
`;
